import i18n from '../i18n'

const defaultQuery = {
  execution_stats: true,
  fields: [],
  selector: {
    _id: { $gt: null }
  },
  sort: [{ '_id': 'desc' }]
}

function toHex (s) {
  let string = unescape(encodeURIComponent(s))
  let hex = ''
  for (let i = 0; i < string.length; i++) {
    hex += string.charCodeAt(i).toString(16)
  }
  return hex
}

const history = {
  state: {
    data: {},
    error: null,
    headers: [
      { text: i18n.t('date'), value: 'date' },
      { text: i18n.t('reference_no'), value: 'reference_no' },
      { text: i18n.t('council'), value: 'council' },
      { text: i18n.t('payment_type'), value: 'payment_type' },
      { text: i18n.t('account_no'), value: 'account_no' },
      { text: i18n.t('amount_rm'), value: 'amount' },
      { text: i18n.t('status'), value: 'status' }
    ],
    items: [],
    loading: false,
    query: defaultQuery
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  mutations: {
    setData: function (state, payload = {}) {
      state.items = payload.data
    },
    setError: function (state, payload = {}) {
      state.error = payload.error
    },
    setLoading: function (state, payload = {}) {
      state.loading = payload.loading
    },
    setQuery: function (state, payload = {}) {
      state.query = payload.query
    }
  },
  actions: {
    fetchPayment: async function (context, payload = {}) {
      const query = context.state.query
      const user = context.rootGetters['auth/hasName']
      const database = 'userdb-' + toHex(user)

      if (payload.limit) query.limit = payload.limit
      else delete query.limit

      context.commit('setLoading', { loading: true })
      try {
        const response = await this.$axios.$post(`${this.app.context.env.API_URL}/query`, { url: btoa(`/${database}/_find`), payload: query })
        if (response.docs.length > 0) {
          context.commit('setData', { data: response.docs })
        }
        context.commit('setError', { error: null })
        return response
      } catch (error) {
        context.commit('setError', { error })
        return { error: error.response.status }
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  }
}

export default history
